import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { ErrorService } from "../../../control-core/services/error.service";
import { initWaitMe, stopWaitMe, WaitMeOptionModel } from "../../../control-core/util/waitme.util";
import { CONTROL_APP_CONST } from "../../config/control-app.constant";
import { DetallePaqueteModel, IDetallePaquete } from "./detalle-notificacion.model";
import { TranslateService } from "@ngx-translate/core";
import { moneymask, SYMBOL_USD } from "../../../control-core/util/moneymask.util";

@Component({
  selector: 'app-detalle-notificacion',
  templateUrl: 'detalle-notificacion.component.html'
})
export class DetalleoNotificacionComponent implements OnChanges {

  @Input() idnotificacion: string;

  @Output() selWarehouse: EventEmitter<{ success: boolean, whr: string }> = new EventEmitter();

  listPaquetes: IDetallePaquete[] = [];

  editaPaquete: IDetallePaquete = new DetallePaqueteModel();

  constructor(private _http: HttpClient,
              private _translate: TranslateService,
              private _errorService: ErrorService) {
  }

  ngOnChanges(changes: SimpleChanges): void {

    if (changes.idnotificacion.currentValue != '' && changes.idnotificacion.currentValue != null) {
      this.consultaDetalle();
    }
  }

  consultaDetalle() {
    let optionWait = new WaitMeOptionModel();

    optionWait.effect = 'win8';

    initWaitMe('#detalle_notificacion', optionWait);

    this._http.get<IDetallePaquete[]>(`${CONTROL_APP_CONST.API_URL}notificaciones/${this.idnotificacion}`)
        .map((response) => {
          response.forEach((valueRes) => {
            if (valueRes.nrogui)
              valueRes.nrogui = this._translate.instant('NROGUI_WVALUE_CLIENTE',
                  {value: valueRes.nrogui});

            if (valueRes.nrowhr) {
              valueRes.shownrowhr = this._translate.instant('NROWHR_WVALUE_CLIENTE',
                  {value: valueRes.nrowhr});
              valueRes.hasWhr = true;

              if (valueRes.tracking)
                valueRes.showtracking = this._translate.instant('TRACKING_WVALUE_CLIENTE',
                    {value: valueRes.tracking});

            } else {
              valueRes.hasWhr = false;
            }

            valueRes.paqdesc = this._translate.instant('PAQDESC_WVALUE_CLIENTE',
                {value: valueRes.paqdesc});

            if (valueRes.peso > 0)
              valueRes.showpeso = this._translate.instant('PESO_WVALUE_CLIENTE',
                  {value: valueRes.peso});

            if (valueRes.valorasegurado)
              valueRes.showvalorasegurado = this._translate.instant('VALORASEGURADO_WVALUE_CLIENTE',
                  {value: moneymask(valueRes.valorasegurado, SYMBOL_USD)});

            if (valueRes.valordeclarado)
              valueRes.showvalordeclarado = this._translate.instant('VALORDECLARADO_WVALUE_CLIENTE',
                  {value: moneymask(valueRes.valordeclarado, SYMBOL_USD)});
          });

          return response;
        })
        .subscribe(
            (response) => {
              this.listPaquetes.splice(0, this.listPaquetes.length);

              this.listPaquetes = response;

              stopWaitMe('#detalle_notificacion');
            }, (error) => {
              this._errorService.manejaError(error);
              stopWaitMe('#detalle_notificacion');
            }
        )
  }

  irWhr(data) {
    if (data) {
      this.selWarehouse.emit({success: true, whr: data});
    } else {
      this.selWarehouse.emit({success: false, whr: ''});
    }
  }

  editPaquete(paquete) {

    let dataUpdate = {
      paquete_id: paquete.id,
      tracking: paquete.tracking
    };

    this._http.put<any>(`${CONTROL_APP_CONST.API_URL}edicionPaquete`, dataUpdate)
        .subscribe(
            (response) => {
              this.consultaDetalle();
            }, (error) => {
              this._errorService.manejaError(error);
            }
        )
  }

}


// WEBPACK FOOTER //
// ./src/app/control-app/shared/detalle-notificacion/detalle-notificacion.component.ts